import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$owner/agents/connected/$clientId")({
	component: ConnectedAgentLayout,
});

/**
 * Layout for one connected app: the detail page (`index`) and each
 * conversation's activity page render here. The detail page owns no outlet
 * of its own, so without this the nested activity route would match but
 * never paint.
 */
function ConnectedAgentLayout() {
	return <Outlet />;
}
